(() => {
  const dialog = document.getElementById('adored-gift-dialog');
  if (!dialog) return;
  let opener;
  let previousOverflow = '';
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-adored-gift-open]');
    if (button && !dialog.open) {
      opener = button;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    if (event.target.closest('[data-adored-gift-close]')) dialog.close();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    opener?.focus();
  });
})();
